import ObjectiveDetails from './ObjectiveDetailsContainer';

export default ObjectiveDetails;
